// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import vuescroll from 'vuescroll';
 import NProgress from 'nprogress'
 import 'nprogress/nprogress.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import i18n from '../src/local'
import axios from 'axios'
import animated  from 'animate.css'
import '../src/fonts/add/iconfont.css'
import '../src/fonts/th/iconfont.css'
import '../src/fonts/f/iconfont.css'
import '../src/fonts/t/iconfont.css'
import '../src/fonts/ins/iconfont.css'
import '../src/fonts/font.css'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

Vue.use(Viewer);
Vue.use(ElementUI)
Vue.use(animated)

Viewer.setDefaults({
  Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})

axios.defaults.baseURL = 'http://www.pan-am.com.cn';
Vue.prototype.$axios=axios
//
// Vue.use(VueI18n)
// Vue.config.lang = 'zh-cn'
// Vue.locale('zh-cn', zhLocale)
// Vue.locale('en', enLocale)

Vue.use(vuescroll);
 NProgress.configure({
       easing: 'ease',  // 动画方式
       speed: 500,  // 递增进度条的速度
       showSpinner: false, // 是否显示加载ico
       trickleSpeed: 200, // 自动递增间隔
       minimum: 0.3 // 初始化时的最小百分比
 })
Vue.prototype.$vuescrollConfig = {
  bar: {
    background: '#F18D00'
  }
};
router.beforeEach((to, from , next) => {
  // 每次切换页面时，调用进度条
  NProgress.start();
  // 这个一定要加，没有next()页面不会跳转的。这部分还不清楚的去翻一下官网就明白了
  next();
});
//当路由进入后：关闭进度条
router.afterEach(() => {
  // 在即将进入新的页面组件前，关闭掉进度条
  NProgress.done()
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js